// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_erpSection__A\\+Zma {
  background-color: var(--background-color1);
  padding: 6rem 0;
}

.styles_sectionTitle__Mmzns {
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
  color: var(--text-color0);
  margin-bottom: 1rem;
}

.styles_divider__EPVpy {
  width: 5rem;
  height: 4px;
  background-color: var(--brand-yellow);
  border: none;
  border-radius: 2px;
  margin: 1.5rem auto 3.5rem auto;
}

.styles_erpGrid__81qAB {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 4rem;
  align-items: center;
}

@media (max-width: 900px) {
  .styles_erpGrid__81qAB {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}

.styles_erpTextContainer__eBi3A {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.styles_erpDetails__OWTNc {
  font-size: 1.1rem;
  color: var(--text-color1);
  line-height: 1.7;
}

.styles_highlight__jBzJS {
  color: var(--brand-yellow);
}

.styles_syncGraphicContainer__qO9oL {
  position: relative;
  width: 100%;
  max-width: 400px;
  height: 400px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_syncSvg__9dqdE {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
}

.styles_syncLine__aO2P5 {
  stroke: var(--brand-yellow);
  stroke-width: 2;
  stroke-dasharray: 8 6;
  animation: styles_syncFlow__ZK03T 8s linear infinite;
  opacity: 0.75;
}

@keyframes styles_syncFlow__ZK03T {
  to {
    stroke-dashoffset: -100;
  }
}

.styles_hubNode__sxTiC {
  position: absolute;
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-hover) 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 800;
  font-size: 0.95rem;
  z-index: 5;
  box-shadow: 0 0 30px rgba(var(--brand-yellow-rgb), 0.4);
}

.styles_hubRipple__MA5R5 {
  position: absolute;
  width: 100px;
  height: 100px;
  border: 2px solid rgba(var(--brand-yellow-rgb), 0.4);
  border-radius: 50%;
  animation: styles_hubPulse__0P8kI 2.5s infinite ease-out;
  pointer-events: none;
  z-index: 3;
}

@keyframes styles_hubPulse__0P8kI {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2.2);
    opacity: 0;
  }
}

.styles_platformNode__eWriU {
  position: absolute;
  width: 95px;
  padding: 0.6rem;
  background-color: var(--background-color1);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  text-align: center;
  font-weight: 700;
  font-size: 0.85rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  z-index: 4;
  color: var(--text-color0);
  transition: all 0.3s ease;
}

.styles_platformNode__eWriU:hover {
  transform: translateY(-3px);
  border-color: var(--brand-yellow);
  box-shadow: 0 6px 20px rgba(var(--brand-yellow-rgb), 0.25);
}

.styles_asaasNode__93Ho6 {
  top: 10%;
  left: 5%;
  border-left: 3px solid #00a1e0;
}

.styles_appClienteNode__sx4Eo {
  top: 10%;
  right: 5%;
  border-left: 3px solid var(--brand-yellow);
}

.styles_appEntregadorNode__8sEyg {
  bottom: 10%;
  left: 5%;
  border-left: 3px solid var(--brand-yellow);
}

.styles_painelNode__y8dHS {
  bottom: 10%;
  right: 5%;
  width: 110px;
  border-left: 3px solid #96bf48;
}

.styles_syncCaption__uslXj {
  text-align: center;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--brand-yellow);
  letter-spacing: 0.05rem;
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/components/ErpSection/styles.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,oDAAsC;EACtC,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,2FAA2F;EAC3F,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oDAAoD;EACpD,kBAAkB;EAClB,wDAA0C;EAC1C,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,0DAA0D;AAC5D;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".erpSection {\n  background-color: var(--background-color1);\n  padding: 6rem 0;\n}\n\n.sectionTitle {\n  font-size: 2.2rem;\n  font-weight: 700;\n  text-align: center;\n  color: var(--text-color0);\n  margin-bottom: 1rem;\n}\n\n.divider {\n  width: 5rem;\n  height: 4px;\n  background-color: var(--brand-yellow);\n  border: none;\n  border-radius: 2px;\n  margin: 1.5rem auto 3.5rem auto;\n}\n\n.erpGrid {\n  display: grid;\n  grid-template-columns: 1.2fr 0.8fr;\n  gap: 4rem;\n  align-items: center;\n}\n\n@media (max-width: 900px) {\n  .erpGrid {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n}\n\n.erpTextContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.erpDetails {\n  font-size: 1.1rem;\n  color: var(--text-color1);\n  line-height: 1.7;\n}\n\n.highlight {\n  color: var(--brand-yellow);\n}\n\n.syncGraphicContainer {\n  position: relative;\n  width: 100%;\n  max-width: 400px;\n  height: 400px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.syncSvg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.syncLine {\n  stroke: var(--brand-yellow);\n  stroke-width: 2;\n  stroke-dasharray: 8 6;\n  animation: syncFlow 8s linear infinite;\n  opacity: 0.75;\n}\n\n@keyframes syncFlow {\n  to {\n    stroke-dashoffset: -100;\n  }\n}\n\n.hubNode {\n  position: absolute;\n  width: 100px;\n  height: 100px;\n  background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-hover) 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 800;\n  font-size: 0.95rem;\n  z-index: 5;\n  box-shadow: 0 0 30px rgba(var(--brand-yellow-rgb), 0.4);\n}\n\n.hubRipple {\n  position: absolute;\n  width: 100px;\n  height: 100px;\n  border: 2px solid rgba(var(--brand-yellow-rgb), 0.4);\n  border-radius: 50%;\n  animation: hubPulse 2.5s infinite ease-out;\n  pointer-events: none;\n  z-index: 3;\n}\n\n@keyframes hubPulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(2.2);\n    opacity: 0;\n  }\n}\n\n.platformNode {\n  position: absolute;\n  width: 95px;\n  padding: 0.6rem;\n  background-color: var(--background-color1);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  text-align: center;\n  font-weight: 700;\n  font-size: 0.85rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  z-index: 4;\n  color: var(--text-color0);\n  transition: all 0.3s ease;\n}\n\n.platformNode:hover {\n  transform: translateY(-3px);\n  border-color: var(--brand-yellow);\n  box-shadow: 0 6px 20px rgba(var(--brand-yellow-rgb), 0.25);\n}\n\n.asaasNode {\n  top: 10%;\n  left: 5%;\n  border-left: 3px solid #00a1e0;\n}\n\n.appClienteNode {\n  top: 10%;\n  right: 5%;\n  border-left: 3px solid var(--brand-yellow);\n}\n\n.appEntregadorNode {\n  bottom: 10%;\n  left: 5%;\n  border-left: 3px solid var(--brand-yellow);\n}\n\n.painelNode {\n  bottom: 10%;\n  right: 5%;\n  width: 110px;\n  border-left: 3px solid #96bf48;\n}\n\n.syncCaption {\n  text-align: center;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--brand-yellow);\n  letter-spacing: 0.05rem;\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"erpSection": `styles_erpSection__A+Zma`,
	"sectionTitle": `styles_sectionTitle__Mmzns`,
	"divider": `styles_divider__EPVpy`,
	"erpGrid": `styles_erpGrid__81qAB`,
	"erpTextContainer": `styles_erpTextContainer__eBi3A`,
	"erpDetails": `styles_erpDetails__OWTNc`,
	"highlight": `styles_highlight__jBzJS`,
	"syncGraphicContainer": `styles_syncGraphicContainer__qO9oL`,
	"syncSvg": `styles_syncSvg__9dqdE`,
	"syncLine": `styles_syncLine__aO2P5`,
	"syncFlow": `styles_syncFlow__ZK03T`,
	"hubNode": `styles_hubNode__sxTiC`,
	"hubRipple": `styles_hubRipple__MA5R5`,
	"hubPulse": `styles_hubPulse__0P8kI`,
	"platformNode": `styles_platformNode__eWriU`,
	"asaasNode": `styles_asaasNode__93Ho6`,
	"appClienteNode": `styles_appClienteNode__sx4Eo`,
	"appEntregadorNode": `styles_appEntregadorNode__8sEyg`,
	"painelNode": `styles_painelNode__y8dHS`,
	"syncCaption": `styles_syncCaption__uslXj`
};
export default ___CSS_LOADER_EXPORT___;
